import { Tooltip } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { Button, ButtonProps, forwardRef } from '@bonusly/design-system';

import { ActionData, useActionData, useActionInput } from '..';
import { useSubmitHandler, useSubmitText } from './submit/hooks';

export type ActionSubmitProps = Omit<ButtonProps, 'children'> & {
	children?: ReactNode | ((data: ActionData) => ReactNode | string);
};

const callOrRender = (children: ReactNode | ((data: ActionData) => ReactNode | string), data: ActionData) => {
	if (typeof children === 'function') {
		return children(data);
	}

	return children;
};

/**
 * The submit button for the entire input state
 */
export const ActionSubmit = forwardRef<ActionSubmitProps, 'button'>(({ children, ...rest }, ref) => {
	const data = useActionData();
	const { tooltipText, submitText } = useSubmitText();
	const handleSubmit = useSubmitHandler();
	const { isSubmitting } = useActionInput();

	return (
		<Tooltip label={tooltipText} hasArrow placement="bottom">
			<Button isLoading={isSubmitting} minWidth="auto" onClick={handleSubmit} ref={ref} {...rest}>
				{callOrRender(children, data) || submitText}
			</Button>
		</Tooltip>
	);
});

ActionSubmit.displayName = 'ActionSubmit';
